import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { UtilService } from 'src/app/shared/services/api-services/util.service';


import * as UserDataConfig from '../../../../src/app/pages/after-apply/config/user-data.config';
@Component({
  selector: 'lib-custom-address-search',
  templateUrl: './custom-address-search.component.html',
  styleUrls: ['./custom-address-search.component.scss']
})
export class CustomAddressSearchComponent implements OnInit {


  public userInputDetail = UserDataConfig.ElementsConfig;
  public addressLine1CodeConfig = this.userInputDetail.addressLine1Config;
  public addressLine2CodeConfig = this.userInputDetail.addressLine2Config;
  public addressLine3CodeConfig = this.userInputDetail.addressLine3Config;
  public addressLine4CodeConfig = this.userInputDetail.addressLine4Config;
  public postCodeConfig = this.userInputDetail.postCodeConfig;
  public countryConfig = this.userInputDetail.countryConfig;
  addressSearchEnabled = false;
  showSearchAddress = false;
  overseasCustomer: boolean;
  isOverseasDoctor = false;
  showIsUKFlag = false;
  private countryName: string;
  private countriesList;

  @Input() address: FormGroup
  @Input() mainParent: FormGroup;
  @Input() index: number = 0
  @Input() personalData;
  @Input() contentData;



  constructor(private utilService: UtilService,) { }

  ngOnInit(): void {

    this.verifyAddressCheck();
    this.getCountriesList();
  }

  verifyAddressCheck() {
    if (this.mainParent.get('ukAddressIndicator').value != '' && this.mainParent.get('ukAddressIndicator').value != null) {
      this.showIsUKFlag = true;
      this.showSearchAddress = true;
      this.overseasCustomer = (this.mainParent.get('ukAddressIndicator').value === 'N') ? true : false;
    } else {
      this.showIsUKFlag = false;
      this.showSearchAddress = false;
      this.overseasCustomer = false;
    }
  }

  onToggleAddressSearch() {
    this.showSearchAddress = !this.showSearchAddress;
  }

  onToggleUKDoctorAddress(event: Event, beneficiaryGroup: FormGroup) {
    const checked = (event.target as HTMLInputElement).checked;
    this.mainParent.get('addressSearchChecked').setValue(checked);
    this.showIsUKFlag = !this.mainParent.get('addressSearchChecked').value
    if (!this.showIsUKFlag) {
      this.mainParent.get('ukAddressIndicator').setValue('');
      this.mainParent.get('ukAddressIndicator').clearValidators();
      this.addressSearchEnabled = false;
      this.showSearchAddress = false;
      this.address.get('addressline1').setValue(this.personalData.line1);
      this.address.get('addressline2').setValue(this.personalData.line2);
      this.address.get('addressline3').setValue(this.personalData.line3)
      this.address.get('addressline4').setValue(this.personalData.line4)
      this.address.get('postcode').setValue(this.personalData.postcode)

    } else {
      this.address.get('addressline1').setValue(null);
      this.address.get('addressline2').setValue(null);
      this.address.get('addressline3').setValue(null)
      this.address.get('addressline4').setValue(null)
      this.address.get('postcode').setValue(null);
      this.address.get('countryCode').setValue(null)
      this.mainParent.get('ukAddressIndicator').setValidators([Validators.required]);
    }
  }

  toggleContainer(data) {

    if (data === 'Y') { 
      this.onToggleAddressSearch();
      this.mainParent.get('ukAddressIndicator').setValue('Y');
      this.address.controls['postcode'].setValidators([Validators.required]);
      this.address.controls['countryCode'].clearValidators();
      this.address.get('countryCode').setValue(null);
      this.countryName = this.address.get('countryCode').value;
      this.overseasCustomer = false;
      this.addressSearchEnabled = true;
      this.isOverseasDoctor = false;
      this.showSearchAddress = false;
      // defect 2806 - Address Line2 is mandatory only for OverseasCustomer
      this.address.controls['addressline2'].clearValidators();
      this.addressLine2CodeConfig.required = false;
    } else {
      this.mainParent.get('ukAddressIndicator').setValue('N');
      // remove validation
      this.address.controls['postcode'].clearValidators();
      this.address.controls['countryCode'].setValidators([Validators.required]);
      this.address.get('postcode').setValue('');
      this.countryName = this.address.get('countryCode').value;
      this.overseasCustomer = true;
      this.addressSearchEnabled = false;
      this.isOverseasDoctor = true;
      this.showSearchAddress = true;
      // defect 2806 - Address Line2 is mandatory only for OverseasCustomer
      this.address.controls['addressline2'].setValidators(Validators.required);
      this.addressLine2CodeConfig.required = true;
      this.address.get('addressline1').setValue(null);
      this.address.get('addressline2').setValue(null);
      this.address.get('addressline3').setValue(null)
      this.address.get('addressline4').setValue(null)
      this.address.get('postcode').setValue(null);
      this.address.get('countryCode').setValue(null);
    }
  }

  onManualClick() {
    this.addressSearchEnabled = !this.addressSearchEnabled;
    this.showSearchAddress = true;
    this.address.get('addressline1').setValue(null);
    this.address.get('addressline2').setValue(null);
    this.address.get('addressline3').setValue(null)
    this.address.get('addressline4').setValue(null)
    this.address.get('postcode').setValue(null);
    this.address.get('countryCode').setValue(null);
  }

  onSelecteAddress(formattedAddress) {
    this.address.get('addressline1').setValue(formattedAddress[0].addressLine1);
    this.address.get('addressline2').setValue(formattedAddress[1].addressLine2);
    this.address.get('addressline3').setValue(formattedAddress[2].addressLine3)
    this.address.get('addressline4').setValue(formattedAddress[3].locality)
    this.address.get('postcode').setValue(formattedAddress[5].postalCode)



    this.showSearchAddress = true;
    this.addressSearchEnabled = false;
  }

  onAddressSeachClick() {
    this.addressSearchEnabled = !this.addressSearchEnabled;
    this.address.get('addressline1').setValue(null);
    this.address.get('addressline2').setValue(null);
    this.address.get('addressline3').setValue(null)
    this.address.get('addressline4').setValue(null)
    this.address.get('postcode').setValue(null);
    this.address.get('countryCode').setValue(null);
    this.showSearchAddress = false;
  }


  getCountriesList() {
    this.countryName = this.address.get('countryCode').value;
    this.utilService.getCountryNames().subscribe(data => {
      if (data) {
        this.countriesList = data;
        if (this.countriesList && this.countriesList.length > 0) {
          this.countryName = (this.countryName) ?
            this.getCountryCode(this.address.get('countryCode').value) : null;
        }

      }
    });


  }

  getCountryCode(value) {
    this.countryName = null;
    if (this.countriesList && this.countriesList.length > 0) {
      const countryNameValue = this.countriesList.filter(val => val['key'] == value);
      this.countryName = (countryNameValue && countryNameValue[0] && countryNameValue[0]['key']) ? countryNameValue[0]['key'] : '';
      this.address.get('countryCode').setValue(this.countryName)
    }
    return this.countryName;
  }
}
